module.exports = __webpack_public_path__ + "static/og-0046d2d8e7e26efee78c8365b30e5297.png";